import { Faq } from 'cpfr-common';
import { AbstractContentState } from '@cp-shared-19/frontend-integration';
import { RootState } from 'store/rootReducer';

export const FaqContentSelector = (state: RootState): AbstractContentState<Faq> => state.content.faq;
